// extracted by mini-css-extract-plugin
module.exports = {"input":"PercentageInput_input__zi-KT","error":"PercentageInput_error__13le3"};